// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.guided-tour-dialog .MuiPaper-root {
  border-radius: 28px;
  overflow: hidden;
  background: linear-gradient(180deg, #fffaf4 0%, #eef3f8 100%);
}

.guided-tour-shell {
  display: grid;
  gap: 18px;
}

.guided-tour-header {
  display: flex;
  gap: 14px;
  align-items: flex-start;
}

.guided-tour-badge {
  min-width: 64px;
  height: 64px;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(145deg, #193e6d 0%, #2c73c6 100%);
  color: #fff9f0;
  box-shadow: 0 16px 28px rgba(22, 53, 92, 0.18);
}

.guided-tour-header-copy {
  display: grid;
  gap: 8px;
}

.guided-tour-overline {
  color: #81563d;
  font: 700 0.76rem/1 "Trebuchet MS", "Gill Sans", sans-serif;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.guided-tour-title {
  margin: 0;
  color: #102033;
  font: 800 1.85rem/1.02 "Trebuchet MS", "Gill Sans", sans-serif;
  letter-spacing: -0.04em;
}

.guided-tour-description {
  margin: 0;
  color: #324860;
  font: 500 0.98rem/1.7 "Trebuchet MS", "Gill Sans", sans-serif;
}

.guided-tour-highlights {
  margin: 0;
  padding-left: 22px;
  color: #1d3652;
}

.guided-tour-highlights li {
  margin-bottom: 10px;
  font: 500 0.96rem/1.65 "Trebuchet MS", "Gill Sans", sans-serif;
}

.guided-tour-footer-note {
  color: #56687d;
  font: 500 0.9rem/1.5 "Trebuchet MS", "Gill Sans", sans-serif;
}

.guided-tour-progress {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.guided-tour-progress-dot {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  background: rgba(25, 62, 109, 0.18);
}

.guided-tour-progress-dot.active {
  background: #2c73c6;
}

@media (max-width: 640px) {
  .guided-tour-header {
    flex-direction: column;
  }
  .guided-tour-badge {
    min-width: 56px;
    height: 56px;
  }
  .guided-tour-title {
    font-size: 1.55rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/guided-tour/GuidedTourModal.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,gBAAA;EACA,6DAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6DAAA;EACA,cAAA;EACA,8CAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;AACF;;AAEA;EACE,cAAA;EACA,2DAAA;EACA,sBAAA;EACA,yBAAA;AACF;;AAEA;EACE,SAAA;EACA,cAAA;EACA,8DAAA;EACA,uBAAA;AACF;;AAEA;EACE,SAAA;EACA,cAAA;EACA,6DAAA;AACF;;AAEA;EACE,SAAA;EACA,kBAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,8DAAA;AACF;;AAEA;EACE,cAAA;EACA,4DAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,eAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mCAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE;IACE,sBAAA;EACF;EAEA;IACE,eAAA;IACA,YAAA;EAAF;EAGA;IACE,kBAAA;EADF;AACF","sourcesContent":[".guided-tour-dialog .MuiPaper-root {\n  border-radius: 28px;\n  overflow: hidden;\n  background: linear-gradient(180deg, #fffaf4 0%, #eef3f8 100%);\n}\n\n.guided-tour-shell {\n  display: grid;\n  gap: 18px;\n}\n\n.guided-tour-header {\n  display: flex;\n  gap: 14px;\n  align-items: flex-start;\n}\n\n.guided-tour-badge {\n  min-width: 64px;\n  height: 64px;\n  border-radius: 20px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(145deg, #193e6d 0%, #2c73c6 100%);\n  color: #fff9f0;\n  box-shadow: 0 16px 28px rgba(22, 53, 92, 0.18);\n}\n\n.guided-tour-header-copy {\n  display: grid;\n  gap: 8px;\n}\n\n.guided-tour-overline {\n  color: #81563d;\n  font: 700 0.76rem/1 'Trebuchet MS', 'Gill Sans', sans-serif;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n}\n\n.guided-tour-title {\n  margin: 0;\n  color: #102033;\n  font: 800 1.85rem/1.02 'Trebuchet MS', 'Gill Sans', sans-serif;\n  letter-spacing: -0.04em;\n}\n\n.guided-tour-description {\n  margin: 0;\n  color: #324860;\n  font: 500 0.98rem/1.7 'Trebuchet MS', 'Gill Sans', sans-serif;\n}\n\n.guided-tour-highlights {\n  margin: 0;\n  padding-left: 22px;\n  color: #1d3652;\n}\n\n.guided-tour-highlights li {\n  margin-bottom: 10px;\n  font: 500 0.96rem/1.65 'Trebuchet MS', 'Gill Sans', sans-serif;\n}\n\n.guided-tour-footer-note {\n  color: #56687d;\n  font: 500 0.9rem/1.5 'Trebuchet MS', 'Gill Sans', sans-serif;\n}\n\n.guided-tour-progress {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.guided-tour-progress-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 999px;\n  background: rgba(25, 62, 109, 0.18);\n}\n\n.guided-tour-progress-dot.active {\n  background: #2c73c6;\n}\n\n@media (max-width: 640px) {\n  .guided-tour-header {\n    flex-direction: column;\n  }\n\n  .guided-tour-badge {\n    min-width: 56px;\n    height: 56px;\n  }\n\n  .guided-tour-title {\n    font-size: 1.55rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
